
import React from "react";
import { useLocation } from "react-router-dom";
import { Navigation } from "@shopify/polaris";
import {
  CustomersMajor,
  HomeMajor,
  ToolsMajor
} from '@shopify/polaris-icons';

export default function AdminNavigation() {
  const location = useLocation();

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            url: "/home",
            label: "Home",
            icon: HomeMajor
          },
          {
            url: "/customers",
            label: "Customer",
            icon:CustomersMajor
          },
          {
            url: "/account",
            label: "Account",
            icon: ToolsMajor
          },
        ]}
      />
    </Navigation>
  );
}